import React from 'react';
import { motion } from 'framer-motion';
import { FileTextIcon, LibraryBigIcon } from 'lucide-react';
import { modules } from '../data/modules';
import { totalVolumes } from '../data/offer';
export function ModulesSection() {
  return <section className="bg-mist py-16 sm:py-20" aria-labelledby="modules-title" data-id="element-152" data-mp="1iw37jof22ta5">
      <div className="mx-auto max-w-6xl px-4" data-id="element-153" data-mp="1dxt831mat6iq">
        <div className="text-center" data-id="element-154" data-mp="2bk8py4in066t">
          <span className="inline-flex items-center gap-2 rounded-full border border-gold/40 bg-deep px-4 py-2 text-xs font-extrabold uppercase tracking-[.15em] text-gold" data-id="element-155" data-mp="2bj7e3xtsrfo1">
            <LibraryBigIcon className="h-4 w-4" data-id="element-156" data-mp="21lszm3rfp0yd" /> Los {totalVolumes} tomos
          </span>
          <h2 id="modules-title" className="mx-auto mt-4 max-w-3xl text-balance text-3xl font-extrabold text-ink sm:text-4xl" data-id="element-157" data-mp="1wmzuozq7qi9t">
            Una guía completa por cada dimensión de la Astronomía
          </h2>
        </div>

        <div className="mt-10 grid gap-5 md:grid-cols-2 lg:grid-cols-3" data-id="element-158" data-mp="l7jle2gwosl9">
          {modules.map((module, index) => {
          const Icon = module.icon;
          return <motion.article key={module.title} initial={{
            opacity: 0,
            y: 16
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            amount: 0.12
          }} transition={{
            duration: 0.3,
            delay: index * 0.04,
            ease: [0.23, 1, 0.32, 1]
          }} className="card-space relative flex flex-col rounded-2xl border border-gold/25 p-6 text-onDark shadow-card" data-id="element-159" data-mp="1nu1vl10jybsi" data-mpi={index}>
                <div className="flex items-start justify-between gap-4" data-id="element-160" data-mp="14x0qzhawudp3">
                  <span className="flex h-11 w-11 items-center justify-center rounded-xl border border-gold/30 bg-petrolDark text-gold" data-id="element-161" data-mp="q7mei0c1fg5h">
                    <Icon className="h-6 w-6" data-id="element-162" data-mp="v3juu6nawmi9" />
                  </span>
                  <span className="font-display text-2xl font-bold text-gold/50" data-id="element-163" data-mp="h76a8onh04zk">Tomo {module.number}</span>
                </div>
                <h3 className="mt-5 text-xl font-bold text-white" data-id="element-164" data-mp="l9kt38r534qu">{module.title}</h3>
                <p className="mt-2 text-sm font-semibold italic text-gold" data-id="element-165" data-mp="2nvgg6a8gzcs9">{module.subtitle}</p>
                <p className="mt-3 text-sm leading-relaxed text-mutedDark" data-id="element-166" data-mp="2j1u9qzswg54w">{module.description}</p>
                <p className="panel-dark mt-4 flex-1 rounded-xl border border-lineDark p-3 text-sm leading-relaxed text-onDark" data-id="element-167" data-mp="2e4vnf3fh92h9">
                  <b className="font-extrabold text-gold" data-id="element-168" data-mp="293enba4thk1q">Resultado: </b>
                  {module.result}
                </p>
                <div className="mt-5 flex flex-col gap-3 border-t border-lineDark pt-4" data-id="element-169" data-mp="31teuxgqpdb8a">
                  <span className="inline-flex items-center gap-1.5 self-start rounded-full bg-gold/15 px-3 py-1 text-xs font-extrabold text-gold" data-id="element-170" data-mp="2wuk0tinac08v">
                    <FileTextIcon className="h-3.5 w-3.5" data-id="element-171" data-mp="2ssoxy9pphesz" /> {module.note}
                  </span>
                  <p className="text-[10px] font-extrabold uppercase tracking-[.1em] text-mutedDark/80" data-id="element-172" data-mp="1lh837pi4cdv5">{module.tags}</p>
                </div>
              </motion.article>;
        })}
        </div>

        <div className="bg-stage-deep starfield mt-8 flex flex-col items-center justify-between gap-4 rounded-2xl border border-gold/40 px-6 py-6 text-center sm:flex-row sm:text-left" data-id="element-173" data-mp="3t39hy75py8en">
          <p className="text-xs font-extrabold uppercase tracking-[.18em] text-gold" data-id="element-174" data-mp="5v5x94r9g6xz">Total de la colección principal</p>
          <p className="font-display text-2xl font-extrabold text-white sm:text-3xl" data-id="element-175" data-mp="apihvi4h3obb">
            {totalVolumes} tomos <span className="mx-2 text-gold" data-id="element-176" data-mp="fov0trs84b8m">·</span> Contenido científico actualizado 2026
          </p>
        </div>
      </div>
    </section>;
}